import {Component, OnInit, ViewChild} from '@angular/core';
import {IonItem, NavController, Platform} from "@ionic/angular";

//import {FingerprintAIO} from '@ionic-native/fingerprint-aio/ngx';
//import Fingerprint = require('cordova-plugin-fingerprint-aio');

import {ApiService} from "@services/api.service";
import {HttpService} from "@services/http/http.service";
import {UiHelperService} from "@services/ui-helper/ui-helper.service";
import {StorageService} from "@services/storage/storage.service";
import {AuthService} from "@services/auth/auth.service";
import {NavParamsService} from "@services/navParams/nav-params.service";

import {appRoutingEnum} from "@enums/appRoutingEnum";
import {Router} from "@angular/router";
declare var Fingerprint: any;


@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
  //providers: [Fingerprint],
  standalone: false
})
export class LoginPage implements OnInit {
  @ViewChild('passwordField') passwordField!: IonItem;
  form: any = {
    errors: {},
    login: {username: {label: ''}, password: {label: ''}}
  };
  errors: any = false;
  header: any;
  user: any = {id: '', name: ''};
  fingerAuth: any;
  enableFingerAuth: any;
  disableFingerAuthInit: any;
  public displayErrors: boolean = false;
  public data:any;
  public resp:any;

  constructor(public navCtrl: NavController,
              public navParams: NavParamsService,
              public api: ApiService,
              public http: HttpService,
              public uiHelper: UiHelperService,
              private storage: StorageService,
              //private faio: Fingerprint,
              public auth: AuthService,
              private plt: Platform,
              public router: Router
  ) {
    this.data = this.navParams.get('data');
    this.http.get(this.http.url + '/user/form/login').subscribe((data: any) => {
      this.form = data;
      this.storage.getItem('fingerAuth').then((val) => {
        // this.faio.isAvailable().then(() => {
        this.plt.ready().then(() => {
          if (this.plt.is('cordova')) {
            Fingerprint.isAvailable().then(() => {
              if (val) {
                 this.fingerAuth = true;
               }
            });
          }
        }).then(result => {
          console.log('Success:', result);
        })
          .catch(error => {
            console.error('Auth failed:', error);
          });
      });

      ['username', 'password'].forEach(field => {
        this.storage.getItem(field).then(value => {
          this.form.login[field].value = value;
        });
      });
    });
    this.resp = {
      username: this.data?.username?.value?? '',
      password: this.data?.password?.value?? ''
    };

    if (navParams.get('page') && navParams.get('page')._id == "logout") {
      this.http.header;
      this.auth.logout();
      this.storage.remove('user_id').then();
      this.storage.remove('user_photo').then();
      this.navCtrl.navigateRoot(appRoutingEnum.MAIN).then();
    }
  }

  /**
   * Posts a login request to the server. Persists data if required, navigates to the necessary page, displays feedback to the user.
   * @type {(type:string)=> void}
   */
  formSubmit() {
    this.displayErrors = false;
    this.uiHelper.keyboard?.hide().then();
    this.auth.formSubmit(this.form.login.username.value, this.form.login.password.value).subscribe(response => {
      if (response.toastMessage) {
        this.uiHelper.presentToast({
          message: "לכניסה לאתר ריצ'דייט יש להעלות תמונה",
          duration: 3000
        });
      }
      if (response.state) {
        this.navParams.set(response.state);
      }
      if (response.destination) {
        this.router.navigate([response.destination]).then();
      }
      if (response.error) {
        this.displayErrors = true;
        this.errors = response.error;
      }else{
        this.close();
      }
    });
  }

  close() {
    this.resp.username = this.data.username.value;
    this.resp.password = this.data.password.value;
    this.uiHelper.dismissModals(this.resp);
  }

  /**
   * Displays a biometric login prompt, and submits it to the server, calling the {@link formSubmit} method.
   * @type {()=> void}
   */
  fingerAuthentication() {
    Fingerprint.show({
      clientId: 'richdate',
      disableBackup: true,  //Only for Android(optional)
      //title: 'Use Pin', //Only for iOS
      //description: 'כניסה לריצדייט באמצעות טביעת אצבע' //Only for iOS
    })
      .then((result: any) => {
        if (result) {
          this.storage.getItem('fingerAuth').then((val) => {
            if (val) {
              if (typeof val == 'object') {
                this.form.login.username.value = val.username;
                this.form.login.password.value = val.password;
              }
              this.formSubmit();
            }
          });
        }
      })
      .catch((err: any) => console.warn('An error has occurred displaying the biometric sign in: ' + err));
  }

  goToRegistrationPage() {
    this.router.navigate([appRoutingEnum.REGISTER]).then();
    this.close();
  }

  goToPasswordRecoveryPage() {
    this.router.navigate([appRoutingEnum.PASSWORD_RECOVERY]).then();
    this.close();
  }

  ionViewDidLoad() {
  }

  ionViewWillEnter() {
    this.api.pageName = appRoutingEnum.LOGIN;
    this.uiHelper.showFooter = false;
    this.uiHelper.showBackButton = false;
    if (this.auth.getIsLogin()) {
      this.router.navigate([appRoutingEnum.HOME]).then();
      this.close();
    }
  }

  ionViewWillLeave() {
    this.uiHelper.showFooter = true;
    this.uiHelper.showBackButton = true;
  }

  ngOnInit() {
  }

  next($event: Event) {
    const target = $event.target as HTMLElement;
    target.closest('ion-item')?.nextElementSibling?.querySelector('input')?.focus();
  }
}
